module.exports = __webpack_public_path__ + "media/categories/20-cdb8723d.svg";